export default {
  model: {
    prop: 'inputValue',
    event: 'change',
  },

  props: {
    noaction: {
      type: Boolean,
      default: false,
    },
    inputValue: null,
    falseValue: null,
    trueValue : null,
    value: {
      required: false,
    },
  },

  computed: {
    isActive() {
      if ((Array.isArray(this.inputValue))) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  methods: {
    toggle() {
      if (this.disabled || this.noaction) return;

      let input = this.inputValue;

      if (Array.isArray(input)) {
        input = input.slice();

        const i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue
          ? null
          : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/ui/mixins/selectable.js